import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/styles.scss";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import TvApp from "./pages/TvApp";
import RemoteApp from "./pages/RemoteApp";

const CommonLayout = ({ children }) => {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12 p-0 m-0">{children}</div>
      </div>
    </div>
  );
};

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        restricted ? <Redirect to="/" /> : <Component {...props} />
      }
    />
  );
};

const pageRoutes = [
  {
    path: "/",
    component: () => <PublicRoute to="/" component={TvApp} />,
    exact: true,
    layout: CommonLayout,
  },
  {
    path: "/tv",
    component: () => <PublicRoute to="/tv" component={TvApp} />,
    exact: true,
    layout: CommonLayout,
  },
  {
    path: "/remote",
    component: () => <PublicRoute to="/remote" component={RemoteApp} />,
    exact: true,
    layout: CommonLayout,
  },
];

const App = () => {
  return (
    <BrowserRouter>
      <Switch>
        {pageRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            component={(props) => (
              <route.layout {...props}>
                <route.component {...props} />
              </route.layout>
            )}
          />
        ))}
      </Switch>
    </BrowserRouter>
  );
};

export default App;

{
  /* <AuthProvider> */
}
{
  /* {window.innerWidth > 648 && <TvApp />}
      {window.innerWidth <= 648 && <RemoteApp />} */
}

{
  /* <div className="d-none d-md-block d-lg-block">
        <TvApp />
      </div>
      <div className="d-sm-inline d-md-none d-lg-none">
        <RemoteApp />
      </div> */
}
{
  /* </AuthProvider> */
}
